import React from 'react';
import {
  IFragmentFragmentScreenDTO,
  IProteinFormulationInfoDTO,
  IProteinFormulationIngredientsDTO,
  IProteinFormulationStandardIngredientsDTO,
} from './Models';
import { IngredientStockDto } from 'components/Experiment/constants';

export interface ProteinFormulationData {
  dropNumber: number;
  dropProteinVolume?: number | null;
  dropWellVolume?: number | null;
  name?: string;
  proteinLotId?: string;
  volume?: number;
  datePrepared?: Date | null;
  storageTemp?: string | number;
  pclass?: string;
  extCoefficient?: string;
  ingredients: IProteinFormulationIngredientsDTO[];
  standardIngredients: IProteinFormulationStandardIngredientsDTO[];
}

export interface WellInfoTemp {
  proteins: ProteinFormulationData[];
  seedIds: number[];
  seedVolumeById: Record<number, number>;
  additives: Additives[];

  wellInfo: WellInfo;

  proteinInfo: IProteinFormulationInfoDTO;

  ingredients: LayerIngredient[];
  dropFragmentInfo: IFragmentFragmentScreenDTO[];
}

export class WellInfo {
  dropProteinVolume: number;
  dropWellVolume: number;
}

export class SeedInfo {
  seedId?: number;
  seedName: string;
  seedVolume?: number;
  sourcePlateId?: number;
  sourceWellName?: string;
  sourceDropNumber?: number;
  sourceExperimentName?: string;
}

export type LayerRowProps = {
  icon: any;
  title: string;
  children?: any;
  onUpdate?: (e) => React.ReactNode;
  onDelete?: (e) => React.ReactNode;
};

export class LayerIngredient {
  ingredientColor: string;

  concentration: number;

  concentrationUnit: string;

  ingredientName: string;

  ingredientTypeName: string;

  ingredientStock?: IngredientStockDto;

  highPhIngStock?: IngredientStockDto;

  highPHVolume?: number;

  ingredientVolume?: number;

  dropNumber?: number;
  pH?: number;
}

export class Additives {
  ingredientColor: string;

  concentration: number;

  concentrationUnit: string;

  ingredientName: string;

  ingredientTypeName: string;

  stockConcentration: number;

  volume: number;
}
